import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';
import { LogoWidget } from '@/pages/landing/components/logowidget';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <!-- <img
                    src="/layout/images/logo-{{
                        isDarkTheme() ? 'white' : 'dark'
                    }}.svg"
                    alt="Zilioo Gar"
                /> -->
                <!-- <logo-widget></logo-widget> -->
                <span class="footer-app-name">Zilioo - Garage</span>
            </div>

            <span class="footer-copyright"
                >&#169; Zion Software - {{ getFullYear() }}</span
            >
        </div>
    `,
    imports: [LogoWidget]
})
export class AppFooter {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());

    getFullYear() {
        return new Date().getFullYear();
    }
}
